import React from 'react';

import Container from '@magoosh/layouts/components/container';
import styles from './style.module.scss';

interface Props {
  children: any;
}

const FullPageOverlay: React.FC<Props> = (props) => {
  return (
    <>
      <div className={styles.fullPageOverlay} />

      <Container className={styles.overlayContent}>
        {props.children}
      </Container>
    </>
  );
};

export default FullPageOverlay;
